import { Device, until } from '@helpers/media';
import { withMotion } from '@hoc/withMotion';
import CtaCard from '@stories/Components/Cards/CtaCard/CtaCard';
import FullWidthCarousel from '@stories/Components/Misc/Carousels/FullWidthCarousel/FullWidthCarousel';
import HeadingSummaryBlock from '@stories/Components/Misc/HeadingSummaryBlock/HeadingSummaryBlock';
import * as React from 'react';
import S from './CtaCards.styles';
const CtaCards = (props) => {
    if (!props.items) {
        return null;
    }
    const sizes = getImageSizes();
    const titleSize = props.columnAmount !== 'two'
        ? 'default'
        : props.items.find((item) => !!item.image)
            ? 'md'
            : 'lg';
    return (React.createElement(S.Outer, { id: props.anchorId, "data-variant": props.sectionColour, "data-visible-columns": props.columnAmount }, props.pageLayout === 'carousel' ? (React.createElement(FullWidthCarousel, { subheading: props.subheading, heading: props.heading, summary: props.summary ? `<p>${props.summary}</p>` : undefined, items: props.items, renderItem: (item) => (React.createElement(CtaCard, { key: item.id, ...item, headingType: "h3", sizes: sizes, titleSize: titleSize })), translations: props.translations })) : (React.createElement(S.Container, { variant: props.sectionColour, translations: props.translations },
        React.createElement(HeadingSummaryBlock, { ...props, summary: props.summary ? `<p>${props.summary}</p>` : undefined, layout: props.summary ? 'split' : 'central' }),
        React.createElement(S.Grid, null, props.items.map((item) => (React.createElement(CtaCard, { key: item.id, ...item, headingType: "h3", sizes: sizes, titleSize: titleSize }))))))));
    function getImageSizes() {
        switch (props.columnAmount) {
            case 'two':
                return `${until(Device.TabletSmall)} 100vw, ${until(Device.DesktopLarge)} 50vw, 840px`;
            case 'four':
                return `${until(Device.TabletSmall)} 100vw, ${until(Device.TabletLarge)} 50vw, ${until(Device.Desktop)} 33vw, ${until(Device.DesktopLarge)} 25vw, 404px`;
            case 'three':
            default:
                return `${until(Device.TabletSmall)} 100vw, ${until(Device.TabletLarge)} 50vw, ${until(Device.DesktopLarge)} 33vw, 550px`;
        }
    }
};
export default withMotion(CtaCards);
